import EfSectionMedia from '@elem/ui/ef-section-media';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    return (
        <div className={styles.TheComp}>
            <EfSectionMedia
                isVideo={true}
                poster="https://websiteoss.ecoflow.com/upload/image/1721290768180/pc_Simple.jpg"
                pc="https://websiteoss.ecoflow.com/upload/video/1721208407681/%E5%AE%89%E8%A3%85%E5%AF%B9%E6%AF%94-pc.mp4"
                pad="https://websiteoss.ecoflow.com/upload/video/1721208407681/%E5%AE%89%E8%A3%85%E5%AF%B9%E6%AF%94-pc.mp4"
                h5="https://websiteoss.ecoflow.com/upload/video/1721208425821/%E5%AE%89%E8%A3%85%E5%AF%B9%E6%AF%94-m.mp4"
                title={t('P_title')}
                desc={t('P_desc')}
            />
            <div className="texts">
                <span className="other text">{t('P_other')}</span>
                <span className="our text">{t('P_our')}</span>
            </div>
            <EfSpec className="spec-xx" />
        </div>
    );
}
